function getSectionName (name) {
  return `【${name}】`
}

export default {
  meta: {
    title: '版本更新',
    dear: '亲爱的FUN友们：',
    header: '为了给大家提供友好的OKR产品服务与体验，OKR系统更新了V2.5.0版本，主要功能如下：'
    // footer: '如需使用以上功能，可以切换回旧版操作。'
  },
  sections: [
    {
      name: '新增',
      content: [
        {
          text: '周报模式：按每个周的纬度填写实现路径当前进展，当前风险，更精准复盘工作进展。',
          highlightStrPos: [[0, 4]]
        },
        {
          text: '我的团队周报(Manger可见)：汇总与自己对齐的员工的实现路径及周报，更清晰把控团队工作进展。',
          highlightStrPos: [[0, 16]]
        },
        {
          text: '团队OKR：展示同部门人员列表，更便捷与同事对齐目标。',
          highlightStrPos: [[0, 5]]
        }
      ]
    },
    {
      name: '优化',
      content: [
        {
          text: '实现路径增加开始时间、结束时间',
          highlightStrPos: []
        },
        {
          text: '目标增加财务目标标签',
          highlightStrPos: []
        },
        {
          text: '可邀请任何员工与自己的OKR对齐，不再局限于同部门',
          highlightStrPos: []
        }
      ]
    }
    // {
    //   name: '待发布',
    //   content: [
    //     {
    //       text: '2.0版本开发中功能：评论、附件上传、目标地图、报表专区',
    //       highlightStrPos: []
    //     }
    //   ]
    // }
  ].map(section => ({
    ...section,
    name: getSectionName(section.name)
  }))
}
